<template>
    <div class="carBox">
        <el-card class="box-card">
            <div class="mainBody">
                <div class="searchBox">
                    <div class="searchGroup">
                        <label>用户名：</label>
                        <el-input v-model="search_Obj.f_username" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>姓名：</label>
                        <el-input v-model="search_Obj.f_realname" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>状态：</label>
                        <el-select v-model="search_Obj.f_state" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                            <el-option v-for="item in enuObj('userstate')" :key="'userstate'+item.key" :label="item.title" :value="item.key"> </el-option>
                        </el-select>
                    </div>
                    <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                    <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
                </div>
                <div class="dataBox">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column type="selection" align="center" width="50"></el-table-column>
                        <el-table-column prop="username" label="用户名" sortable="custom" width="150"></el-table-column>
                        <el-table-column prop="realname" label="姓名" sortable="custom" width="150"></el-table-column>
                        <el-table-column prop="state" label="状态" sortable="custom" width="120">
                            <template slot-scope="scope">
                                <span>{{ transEnu(scope.row.state, "userstate") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="rolenames" label="角色信息" sortable="custom"></el-table-column>
                        <el-table-column prop="lastlogindate" label="最后登录" sortable="custom"></el-table-column>
                        <el-table-column label="操作" width="400" align="center">
                            <template slot-scope="scope">
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox">
                    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
                <Edit
                    width="600px"
                    :id="model_id"
                    :title="edit_title"
                    :isshow="editshow"
                    @on-close="closeEditDialog"
                    @on-save-ok="saveOk">
                </Edit>
                <ProjectList
                    width="800px"
                    :user_id="model_id"
                    title="分配项目"
                    :isshow="projectshow"
                    @on-close="closeProjectDialog">
                </ProjectList>
                <SetRole
                    width="400px"
                    :id="model_id"
                    title="分配角色"
                    :isshow="infoshow"
                    @on-close="closeRoleDialog">
                </SetRole>
            </div>
        </el-card>
    </div>
</template>

<script>
import Btns from "@/components/common/btns";
import LabBtns from "@/components/common/labbtns";
import Edit from "./projectuseredit";
import ProjectList from "./projectlist1";
import SetRole from "../user/setrole";
import listutil from "@/libs/listutil";
import { resetPass } from "@/api/user";

export default {
    name: 'superUserList',
    mixins: [listutil],
    components: {Edit, ProjectList, SetRole, Btns, LabBtns},
    data() {
        return {
            m_name: '多项目用户',
            menu_id: 1160,
            list_url: "/api/admin/groupuser/projectList",
            enu_name: ["userstate"],
            search_Obj: {
                f_username: '',
                f_realname: '',
                f_state: '',
                org_id: '',
            },
            del_Obj:{
                url:'/api/admin/groupuser/projectDel',
                data:{
                    ids:''
                }
            },
            projectshow: false,
            pagesize: 100,
        };
    },
    methods: {
        resetPassword(index, row){
            this.$confirm('确定要重置用户【'+row.realname+'】的密码吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                resetPass(row.id).then(res=>{
                    if(res.code ==1){
                        this.$msgs(res.msg)
                    }else{
                        this.$msg(res.msg)
                    }
                })
            }).catch(() => {})
        },
        roleSet(index, row){
            this.model_id = row.id
            this.infoshow = true
        },
        closeRoleDialog(){
            this.infoshow = false
            this.getListData()
        },
        loadOtherData() {
            
        },
        projectSet(index, row) {
            this.model_id = row.id
            this.projectshow = true
        },
        closeProjectDialog(){
            this.projectshow = false
        },
    }
};
</script>